/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Placewebdescriptionplaceholder3Inputs */

const en_placewebdescriptionplaceholder3 = /** @type {(inputs: Placewebdescriptionplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A few sentences about the place`)
};

const de_placewebdescriptionplaceholder3 = /** @type {(inputs: Placewebdescriptionplaceholder3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ein paar Sätze über den Ort`)
};

/**
* | output |
* | --- |
* | "A few sentences about the place" |
*
* @param {Placewebdescriptionplaceholder3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const placewebdescriptionplaceholder3 = /** @type {((inputs?: Placewebdescriptionplaceholder3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Placewebdescriptionplaceholder3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_placewebdescriptionplaceholder3(inputs)
	return de_placewebdescriptionplaceholder3(inputs)
});
export { placewebdescriptionplaceholder3 as "placeWebDescriptionPlaceholder" }